module.exports = __webpack_public_path__ + "static/media/leaves_2.dafcb1bd.png";